// extracted by mini-css-extract-plugin
module.exports = {"main":"Product_main__29Sly","image":"Product_image__1zepN","productInfo":"Product_productInfo__e0ZlB"};